import { lighten, darken } from 'polished';
import {
  ICanvasElement,
  ICanvasElementDrawArgs,
  IPositionXY
} from '@/models/marketingCenter/canvas';
import {
  MarketingCenterColorSchemeDictionary,
  TMarketingCenterColorScheme
} from '../colorScheme';
import {
  getHTMLImage,
  printAtWithBreakStrategy,
  roundRect
} from '@/utils/canvas';

class NotificationCanvasElement implements ICanvasElement {
  constructor(
    private readonly options: {
      position: IPositionXY;
      dimensions?: {
        width: number;
        height: number;
      };
      message?: string;
    }
  ) {}

  showOnPreview = true;

  APP_NAME = 'TWISM';
  SENT_AT = 'now';

  defaultMessage = 'You received 1.2 Coins after spending $18.00 with us';
  defaultDimension = {
    width: 210,
    height: 65
  };

  colors!: TMarketingCenterColorScheme;
  x!: number;
  y!: number;
  width!: number;
  height!: number;
  paddingLeft!: number;
  paddingTop!: number;

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    const { dimensions = this.defaultDimension, position } = this.options;

    const { x, y } = position;

    this.colors = MarketingCenterColorSchemeDictionary[args.color];
    this.x = x;
    this.y = y;
    this.width = dimensions.width;
    this.height = dimensions.height;
    this.paddingLeft = this.x + 7;
    this.paddingTop = this.y + 7;

    await this.drawBackground(context);
    await this.drawCoins(context);
    await this.drawStatic(context);
    await this.drawBusinessName(context, args);
    await this.drawMessage(context);
  }

  async drawBackground(context: CanvasRenderingContext2D) {
    context.fillStyle = lighten(0.14, this.colors.primary);
    roundRect(context, this.x, this.y, this.width, this.height, 8, true, false);
  }

  async drawCoins(context: CanvasRenderingContext2D) {
    const url = require(`../../../assets/img/marketingCenter/canvas/notification-coins.png`);
    const img = await getHTMLImage(url);

    context.drawImage(img, this.x + 70, this.y - 36, 122, 73);
  }

  async drawStatic(context: CanvasRenderingContext2D) {
    const url = require(`../../../assets/img/marketingCenter/canvas/logo.svg`);
    const img = await getHTMLImage(url);

    context.drawImage(img, this.paddingLeft, this.paddingTop);

    context.font = 'normal 7px "Inter"';
    context.fillStyle = darken(0.2, this.colors.primary);
    context.fillText(
      this.APP_NAME,
      this.paddingLeft + 18,
      this.paddingTop + 9.5
    );
    context.fillText(this.SENT_AT, this.width - 7, this.paddingTop + 9.5);
  }

  async drawBusinessName(
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ) {
    context.font = '700 8px "Inter"';
    context.fillStyle = '#000';
    context.fillText(
      args.business.name,
      this.paddingLeft,
      this.paddingTop + 27,
      this.width - this.paddingLeft
    );
  }

  async drawMessage(context: CanvasRenderingContext2D) {
    context.font = 'normal 7px "Inter"';
    context.fillStyle = '#000';
    printAtWithBreakStrategy(
      (...props) => context.fillText(...props),
      context,
      this.options.message || this.defaultMessage,
      this.paddingLeft,
      this.paddingTop + 39,
      10.6,
      this.width - this.paddingLeft
    );
  }
}

export default NotificationCanvasElement;
